import { render, staticRenderFns } from "./LayoutTemplate1.vue?vue&type=template&id=24f03ece&"
import script from "@/scripts/LayoutTemplate/index.js?vue&type=script&lang=js&"
export * from "@/scripts/LayoutTemplate/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports